import React from "react";
import imageUrl from "utils/imageUrl";
function Steps() {
  return (
    //  <!-- ==== start step section start ==== -->
    <section className="start start--two section__space__top">
      <div className="container">
        <div className="start__area wow fadeInUp">
          <div className="section__header">
            <h5 className="neutral-top">We're changing the way you invest.</h5>
            <h2>For Lenders</h2>
            <p className="neutral-bottom">
              Signing up with Revest is simple and only takes a few minutes. We
              can automatically connect with more than 3,500 banks, so no
              complicated paperwork is required to fund your account.
            </p>
          </div>
          <div className="row">
            <div className="col-md-6 col-xl-4">
              <div className="start__single__item column__space--secondary">
                <div className="img__box">
                  <img
                    src={imageUrl("home/browse.png")}
                    alt="Browse Properties"
                  />
                  <div className="step__count">
                    <h4>01</h4>
                  </div>
                </div>
                <h4>Asset Security</h4>
                <p className="neutral-bottom">
                  No need to transfer a rented NFT to the tenant, ensuring that
                  the NFT does not incur any losses or theft.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-xl-4">
              <div className="start__single__item column__space--secondary">
                <div className="img__box arrow__container">
                  <img
                    src={imageUrl("home/invest.png")}
                    alt="View Details & Invest"
                  />
                  <div className="step__count">
                    <h4>02</h4>
                  </div>
                </div>
                <h4>Complete Control</h4>
                <p className="neutral-bottom">
                  Retrieve your staked NFT whenever (as long as it’s not
                  rented), modify rental information at any time.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-xl-4">
              <div className="start__single__item">
                <div className="img__box">
                  <img src={imageUrl("home/earn.png")} alt="Earn and Track" />
                  <div className="step__count">
                    <h4>03</h4>
                  </div>
                </div>
                <h4>Batch Listing</h4>
                <p className="neutral-bottom">
                  List multiple NFTs all at once.
                </p>
              </div>
            </div>
          </div>

          <div className="w-100 text-center">
            <a
              href="javascript:void(0)"
              class="button button-primary button--effect my-5 "
            >
              {" "}
              Lend Now <i class="fa-solid fa-arrow-right-long"></i>{" "}
            </a>
          </div>
        </div>
      </div>
    </section>
    // <!-- ==== #start step section end ==== -->
  );
}

export default Steps;
